import RecruiterLayerBlueprint from "components/blueprints/RecruiterLayerBlueprint";
import React from "react";

function RecruiterSettingsIntegrationsPage() {
  return <div>RecruiterSettingsIntegrationsPage</div>;
}

export default RecruiterLayerBlueprint(RecruiterSettingsIntegrationsPage);
